import React from "react";
import {FullScreenLayout, Screen} from "../components/layout";
import M from "../../strings";
import {changePassword} from "../../actions/account";
import MobileLayout from "../components/mobile/layout";
import { MobilePasswordInput } from "../components/mobile/forms";
import { logout } from "../../actions/session";

export default class ChangePassword extends Screen {

    constructor(props) {
        super(props)

        this.state = {};
        this.formRef = React.createRef();
    }

    logout() {
        logout()
    }

    changePassword(e) {
        e && e.preventDefault()
        changePassword({password: this.state.password, passwordConfirm: this.state.passwordConfirm, currentPassword: this.state.currentPassword})
    }

    updatePassword(value) {
        this.state.password = value.target.value;
    }

    updatePasswordConfirm(value) {
        this.state.passwordConfirm = value.target.value;
    }

    updateCurrentPassword(value) {
        this.state.currentPassword = value.target.value;
    }

    render() {
        return (
            <MobileLayout
                hideHeader={true}
            >
                <div
                    className="container"
                >
                    <div
                        className="row justify-content-center"
                    >
                        <div
                            className="login__wrapper col-12 col-md-8 col-lg-6"
                        >
                            <div
                                className="login__logo"
                            >
                                <img
                                    src="resources/images/logo.svg"
                                />
                            </div>
                            <h4
                                className="login__header"
                            >
                                {M("welcome")}
                            </h4>
                            <form
                                ref={this.formRef}
                                className="login__form"
                                action=""
                                onSubmit={this.changePassword.bind(this)}
                            >
                                <p>
                                    {M("changePasswordDescription")}
                                </p>
                                <MobilePasswordInput
                                    name="password"
                                    label={M("currentPassword")}
                                    placeholder={M("currentPassword")}
                                    onChange={this.updateCurrentPassword.bind(this)}
                                />
                                <MobilePasswordInput
                                    name="password"
                                    label={M("password")}
                                    placeholder={M("password")}
                                    onChange={this.updatePassword.bind(this)}
                                />
                                <MobilePasswordInput
                                    name="confirmPassword"
                                    label={M("passwordConfirm")}
                                    placeholder={M("passwordConfirm")}
                                    onChange={this.updatePasswordConfirm.bind(this)}
                                />
                                <div
                                    className="login__btn"
                                >
                                    <button
                                        type="submit"
                                        className="btn btn-block btn-primary"
                                        onClick={this.changePassword.bind(this)}
                                    >
                                        {M("submit")}
                                    </button>
                                </div>
                                <div
                                    className="login__btn"
                                >
                                    <button
                                        type="button"
                                        className="btn btn-block btn-outline-primary"
                                        onClick={this.logout.bind(this)}
                                    >
                                        {M("logout")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </MobileLayout>
        )
    }


}


